import React from 'react';
import Image from 'react-bootstrap/Image';

import icon from '../giticon.png'

const GithubFooter = () => (
  <a href="https://github.com/whimc/Path-Displayer">
    <Image src={icon} height="50px"/>
  </a>
);

export default GithubFooter;
